import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { RecordsCoudPouce } from '@classes/records/record';
import { Step } from '@classes/step/step';
import { UserPlatform } from '@classes/user/user-platform';
import { faChevronLeft, faEdit, faFileExcel, faPrint, faSearch } from '@fortawesome/free-solid-svg-icons';
import { CategoriesService } from '@services/categories/categories.service';
import { ConvertDateService } from '@services/convert-date/convert-date.service';
import { DataService } from '@services/data/data.service';
import { RecordsService } from '@services/records/records.service';
import { UsersService } from '@services/users/users.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { UserUpdateComponent } from '../user-update/user-update.component';

const reader = new FileReader();

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent extends SubscriptionBaseComponent implements OnInit {

  faEdit = faEdit;
  faFileExcel = faFileExcel;
  faChevronLeft = faChevronLeft;
  faSearch = faSearch;
  faPrint = faPrint;

  userName: string;
  isActive: boolean;
  isActiveValue: boolean;
  color: ThemePalette = 'primary';
  user: UserPlatform;

  dataUserForm: FormGroup;
  today = new Date();

  filterValueRecords = null;
  sortValueRecords: string;
  recordsList: RecordsCoudPouce[];
  paginationRecords: Pagination;

  arrayTri: RecordsCoudPouce[] = [];
  arrayCintrage: RecordsCoudPouce[] = [];
  arrayTriClicotte: RecordsCoudPouce[] = [];
  arrayGoodCart: RecordsCoudPouce[];

  weightTri = 0;
  weightTriClicotte = 0;
  weightTriDechet = 0;
  weightGoodCart = 0;


  arrayCintrageShoesAcc = 0;
  arrayCintrageMen = 0;
  arrayCintrageWommen = 0;
  arrayCintrageKids = 0;
  cintrageTotalValue = 0;

  arrayVente: RecordsCoudPouce[] = [];
  arrayVenteShoesAcc = 0;
  arrayVenteMen = 0;
  arrayVenteWommen = 0;
  arrayVenteKids = 0;
  arrayVenteSelection = 0;
  arrayVenteCreation = 0;
  venteTotalValue = 0;
  users: UserPlatform[];
  imgUserDefault: string;




  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private usersService: UsersService,
    private router: Router,
    private formBuilder: FormBuilder,
    private convertDateService: ConvertDateService,
    private recordsService: RecordsService,
    private dataService: DataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.recordsService.eventsListSubject.next(null);
    this.getUSers();
    this.initForm();
  }

  openDialogUpdateUser(): void {
    const dialogRef = this.dialog.open(UserUpdateComponent, {
      data: {
        user: this.user
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        const params = { username: res.username, isActive: res.isActive };
        this.isActive = res.isActive;
        this.isActiveValue = res.isActive;
        this.userName = res.username;
        this.user = res;
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: params });
      }
    });
  }

  isActiveOrNot(): void {
    this.isActiveValue === true ?
      this.usersService.desactivateUser(this.user.id).subscribe(() => { this.isActiveValue = !this.isActiveValue; }) :
      this.usersService.activateUser(this.user.id).subscribe(() => { this.isActiveValue = !this.isActiveValue; });
  }

  onSubmit(origin: string): void {
    this.filterValueRecords = {
      username: null,
      step: null,
      category: null,
      dateFrom: null,
      dateTo: null
    };

    this.arrayCintrage = [];
    this.arrayTri = [];
    this.arrayVente = [];
    this.arrayTriClicotte = [];
    this.arrayGoodCart = [];

    const from = this.dataUserForm.get('from').value;
    const to = this.dataUserForm.get('to').value;


    this.filterValueRecords.username = this.route.snapshot.queryParams.username;

    if (from) {
      this.filterValueRecords.dateFrom = this.convertDateService.convertDate(from);
    }

    if (to) {
      this.filterValueRecords.dateTo = this.convertDateService.convertDate(to, true);
    }

    switch (origin) {
      case 'submit':
        this.getRecordsWithFilterReturnFirstPage();
        break;
      case 'export':
        this.getFileForExportRecords();
        break;
      default:
        break;
    }
  }

  private getRecordsWithFilterReturnFirstPage(): void {
    const newRequest = new PaginationRequest(
      this.filterValueRecords,
      this.sortValueRecords,
      null,
      null
    );
    this.recordsService.getRecords(newRequest);
  }

  getFileForExportRecords(): void {
    const newRequest = new PaginationRequest(
      this.filterValueRecords,
      this.sortValueRecords,
      this.paginationRecords.pageNumber,
      this.paginationRecords.totalRecords
    );

    this.recordsService.exportRecords(newRequest);
  }

  printData(): void {
    window.print();
  }

  private getUSers(): void {
    const id = this.route.snapshot.queryParams.id;
    this.usersService.getUser().subscribe(res => {
      this.user = res.find(user => user.id === id);
      this.isActive = this.user.isActive;
      this.isActiveValue = this.user.isActive;
      this.userName = this.user.username;
      this.getUserPhoto();
      this.initSub();

    });
  }

  private getUserPhoto(): void {

    if (this.user.hasPhoto) {

      this.usersService.getPhotoUser(this.user.id).subscribe(img => {
        reader.readAsDataURL(img);
        reader.onload = (res) => {
          this.imgUserDefault = res.target.result.toString();
        };
      });
    } else {
      this.imgUserDefault = 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';

    }
  }

  private initSub(): void {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const dateFrom = new Date(year, month, 1);

    this.filterValueRecords = {
      username: null,
      step: null,
      category: null,
      dateFrom: null,
      dateTo: null
    };

    this.filterValueRecords.username = this.user.username;
    this.filterValueRecords.dateTo = this.convertDateService.convertDate(date.toString(), true);
    this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());

    this.recordsService.getRecords(new PaginationRequest(this.filterValueRecords, this.sortValueRecords, 1, 34));
    this.subscription
      .add(
        this.recordsService.eventsListSubject
          .subscribe(events => {
            this.recordsList = events?.body;

            this.arrayTri = this.recordsList?.filter(r => r.step.description === 'Tri');
            this.arrayCintrage = this.recordsList?.filter(r => r.step.description === 'Cintrage');
            this.arrayVente = this.recordsList?.filter(r => r.step.description === 'Fripeschic' && r.type === 'Input');
            this.arrayGoodCart = this.arrayTri?.filter(r => r.category.name === 'Chariots de marchandises');

            this.paginationRecords = events?.pagination;

            this.weightTriClicotte = 0;
            this.weightTriDechet = 0;
            this.weightGoodCart = 0;

            this.arrayTri?.forEach(item => {
              this.weightTri = this.weightTri + item.value;
              switch (item.category?.name) {
                case 'Clicotte':
                  this.weightTriClicotte = this.weightTriClicotte + item.value;
                  break;
                case 'Déchetterie':
                  this.weightTriDechet = this.weightTriDechet + item.value;
                  break;
                default:

                  break;
              }
            });

            this.arrayGoodCart?.forEach(r => {
              this.weightGoodCart += r.value;
            });

            this.arrayCintrageShoesAcc = 0;
            this.arrayCintrageMen = 0;
            this.arrayCintrageWommen = 0;
            this.arrayCintrageKids = 0;
            this.cintrageTotalValue = 0;

            this.arrayCintrage?.forEach(item => {

              switch (item.category.name) {
                case 'Chaussures/Accessoires':
                  this.arrayCintrageShoesAcc = this.arrayCintrageShoesAcc + item.value;
                  this.cintrageTotalValue = this.cintrageTotalValue + item.value;
                  break;
                case 'Homme':
                  this.arrayCintrageMen = this.arrayCintrageMen + item.value;
                  this.cintrageTotalValue = this.cintrageTotalValue + item.value;

                  break;
                case 'Femme':
                  this.arrayCintrageWommen = this.arrayCintrageWommen + item.value;
                  this.cintrageTotalValue = this.cintrageTotalValue + item.value;

                  break;
                case 'Enfant':
                  this.arrayCintrageKids = this.arrayCintrageKids + item.value;
                  this.cintrageTotalValue = this.cintrageTotalValue + item.value;
                  break;

                default:
                  break;
              }
            });

            this.arrayVenteShoesAcc = 0;
            this.arrayVenteMen = 0;
            this.arrayVenteWommen = 0;
            this.arrayVenteKids = 0;
            this.arrayVenteSelection = 0;
            this.arrayVenteCreation = 0;
            this.venteTotalValue = 0;

            this.arrayVente?.forEach(item => {
              switch (item.category?.subCategory?.name) {
                case 'Chaussures/Accessoires':
                  this.arrayVenteShoesAcc = this.arrayVenteShoesAcc + item.value;
                  this.venteTotalValue = this.venteTotalValue + item.value;
                  break;
                case 'Homme':
                  this.arrayVenteMen = this.arrayVenteMen + item.value;
                  this.venteTotalValue = this.venteTotalValue + item.value;

                  break;
                case 'Femme':
                  this.arrayVenteWommen = this.arrayVenteWommen + item.value;
                  this.venteTotalValue = this.venteTotalValue + item.value;

                  break;
                case 'Enfant':
                  this.arrayVenteKids = this.arrayVenteKids + item.value;
                  this.venteTotalValue = this.venteTotalValue + item.value;
                  break;
                case 'Sélection':
                  this.arrayVenteSelection = this.arrayVenteSelection + item.value;
                  this.venteTotalValue = this.venteTotalValue + item.value;
                  break;
                case 'Création':
                  this.arrayVenteCreation = this.arrayVenteCreation + item.value;
                  this.venteTotalValue = this.venteTotalValue + item.value;
                  break;

                default:
                  break;
              }
            });
          })
      );


  }

  private initForm(): void {
    const year = this.today.getFullYear();
    const month = this.today.getMonth();
    const firstDayofMonth = new Date(year, month, 1);
    const firstDayOfMonth = new Date(year, month, 1);

    this.dataUserForm = this.formBuilder.group({
      from: [firstDayOfMonth],
      to: [this.today]
    });
  }

}
